module.exports = __webpack_public_path__ + "32b1c21221a307bc7d7eec34db83ba81.ttf";